module.exports = __webpack_public_path__ + "static/cf-bold-italic-9c2f8b20b0995ebd51702e39df9d747d.woff";